//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { jssdk, isIphonex } from '@runwork/runwork-help'
import { BoardRadio, BoardCheckbox, BoardBlank, BoardSection } from './board'
export default {
  props: {
    question: {
      type: Object,
      default: () => {},
    },
  },
  components: { BoardRadio, BoardCheckbox, BoardBlank, BoardSection },
  computed: {
    isIphonex() {
      return isIphonex() && this.platform === 3
    },
    isrunwork2() {
      return isIphonex() && this.platform === 2
    },
  },
  watch: {
    question: {
      handler(newV) {
        this.curQuestion = { ...newV }
      },
      immediate: true,
    },
  },
  data() {
    return {
      curQuestion: {},
    }
  },
  methods: {
    addQuestion(item) {
      let form = this.$refs[`board-${this.question.type}`]
      let question = this.question
      if (form) {
        question = form.getValue()
      }
      this.$emit('onadd', question)
    },
  },
}
